import { BoardItem } from '@gorilla/common/src/lib/monday-api/api';
import { createPreviewToken } from './portal';
import { monday } from './monday';

const WINDOW_ID = 'portal-preview';

function writeLoadingMessage(previewWindow: Window, clientName?: string, scope?: string) {
  previewWindow.document.write(`
            <!DOCTYPE html>
            <html lang="en">
            <head>
                <title>Loading</title>
                <style>
                    body {
                      font-family: sans-serif;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      height: 98vh; /* Use vh for height */
                      margin: 0;
                      background-color: #f6f7fb;
                    }
                    .loading-text {
                      overflow: hidden;
                      padding: 16px 24px;
                      max-width: 400px;
                      background-color: #fff;
                      border: 1px solid #d0d4e4;
                      border-radius: 4px;
                      box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
                      font-size: 14px;
                      line-height: 20px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      color: #323338;
                    }
                </style>
            </head>
            <body>
                <div class="loading-text">
                    Loading ${scope === 'draft' ? `<strong>working draft</strong>` : '<strong>published portal</strong>'} ${clientName ? ` for <strong>${clientName}</strong>` : ''}
                </div>
            </body>
            </html>
        `);
  // Close the stream to ensure content is rendered
  previewWindow.document.close();
}

export function openPreviewWindow(clientBoardId: number, clientBoardItemId: number | BoardItem, scope: 'draft' | 'public', page = 'start') {
  let tokenLoaded = false;
  const previewWindow = window.open('about:blank', WINDOW_ID, 'left=50,top=50,width=1440,height=800');

  if (previewWindow) {
    previewWindow.location.href = 'about:blank';

    setTimeout(() => {
      if (!tokenLoaded) {
        writeLoadingMessage(previewWindow, typeof clientBoardItemId === 'number' ? undefined : clientBoardItemId.name, scope);
      }
    }, 200);
  }

  const tokenPromise = createPreviewToken(
    clientBoardId,
    typeof clientBoardItemId === 'number' ? clientBoardItemId : clientBoardItemId.id,
    scope,
  );

  return tokenPromise.then((tokenResult) => {
    const tokenBase64 = btoa(JSON.stringify(tokenResult));
    // @ts-ignore
    const previewUrl = `${import.meta.env.VITE_APP_CLIENT_PORTAL_PREVIEW_URL}/preview?token=${encodeURIComponent(tokenBase64)}&page=${encodeURIComponent(page)}`;
    tokenLoaded = true;

    if (previewWindow) {
      previewWindow.location.href = previewUrl;
      previewWindow.focus();
    } else {
      // for example in the monday electron app
      monday.execute('openLinkInTab', { url: previewUrl });
    }
  });
}
